import React from "react";
import { Routes, Route, Navigate, } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout";
import Dashboard from "../pages/branch/Dashboard";
import Members from "../pages/branch/Members";
import ProfileVerification from "../pages/branch/ProfileVerification";
import Wallets from "../pages/branch/Wallets";
import Reports from "../pages/branch/Reports";
import Matches from "../pages/branch/Matches";
function BranchRoutes() {
    return (
        <Routes>``
            <Route element={<AdminLayout />}>
                <Route index element={<Navigate to="dashboard" replace />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="members" element={<Members />} />
                <Route path="profile-verification" element={<ProfileVerification />} />
                <Route path="wallets" element={<Wallets />} />
                 <Route path="reports" element={<Reports />}/>
                 <Route path="matches" element={<Matches />}/>
            </Route>

        </Routes>
    );
}

export default BranchRoutes;